import {
  AnnouncementState,
  LOADED_ANNOUNCEMENTS,
  LOADING_ANNOUNCEMENTS,
  AnnouncementActionTypes,
} from './types';

const initialState = {
  globalAnnouncements: [],
  myEcriAnnouncement: null,
  loading: false,
  loaded: false,
};

const reducer = (
  state: AnnouncementState = initialState,
  action: AnnouncementActionTypes
): AnnouncementState => {
  switch (action.type) {
    case LOADED_ANNOUNCEMENTS: {
      return {
        ...action.payload,
        loading: false,
        loaded: true,
      };
    }
    case LOADING_ANNOUNCEMENTS: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
